module.exports = __webpack_public_path__ + "media/my_images/owner/step2-38686b47bd8fa717e20d962e3167ec2b.svg";